module.exports = __webpack_public_path__ + "static/media/planta4.a9f61445.jpg";